export const projects = [
  {
    title: "Developement of Drone based infrastructure for Agriculture.",
    subtitle: "",
    description: "This module consists of developing the quad copter following appropriate design for proper aviation. Addition to it will be inclusion of various features for the application. This module consists both of software and hardware implementation.",
    image: "./drone.jpg",
    link: "https://drive.google.com/drive/folders/1iCVTffzb5gKGmS7r-jJhpBwH5kJvAdQT?usp=sharing",
  },
  {
    title: "Jataayu Smart Panel",
    subtitle: "",
    description:
      "This is a handheld smart monitoring and visualization panel which collects and displays the environmental factors like temperature, humidity, weather forcast, soil moisture content and live video feed from the drone for better analysis and decision making.",
    image: "./jataayu-monitor-panel.jpg",
    link: "https://drive.google.com/drive/folders/1Ycq6Vx1ltBaFMsOYJKjx787Mrf83jKvo?usp=sharing",
  },
  {
    title: "Solar Powered Automated Robot (SPARk)",
    subtitle: "",
    description: "A multi purpose Solar powered automated robot for agriculture. This machine can be used as a weed remover, garbage collector, crop carrier, etc.",
    image: "./spark1.jpg",
    link: "https://drive.google.com/drive/folders/1ohNbE1Rv5I_NLbToXFHM_u-GVl4lrWxo?usp=sharing",
  },
  {
    title: "Agri Suite",
    subtitle: "",
    description: "This module consists of designing and developing a smart monitor panel which is a compact hand held device for monitoring the ground conditions and other concerned factors. It too is designed keeping in mind it's ease of use and it's durability.",
    image: "./agrisuite.jpg",
    link: "https://drive.google.com/drive/folders/1eooiBSKMob9fnaWDCUQbpN3pq1l5_tFI?usp=sharing",
  },
];
export const testimonials = [
  {
    quote: "Aravind places himself to be one of the most reliable resource. His postive attitude towards challenges and quick learning capability makes him special in the team. Combined with excellent problem solving skills and experience in scaling solutions, Aravind is a great fit for engineering intensive roles!",
    image: "./gk.jpg",
    name: "GaneshKumar K R",
    company: "Associate Director of Product, Rakuten India",
  },
  {
    quote: "Aravind pays attention to and recognizes security aspects and their implications on projects and products. He's  proactive in coming up with queries and suggestions to improve security. He's committed to getting in-depth knowledge of whatever stack he's working on and using that to continuously improve himself, others and the product. He has a good eye for detail in interpreting specifications into actual features. His energetic attitude is infectious and is an asset to any team that he's a part of.",
    image: "./aditya.png",
    name: "Adithya Chebiyyam",
    company: "Senior Member of Technical Staff, VMWare",
  },
];

export const skills = [
  "Java",
  "SpringBoot",
  "React",
  "MySQL",
  "JavaScript",
  "Kotlin",
  "Golang",
];

export const hobbies = [
  "Bee keeping",
  "Agriculture",
  "Design and fabrication of small-scale agricultural instruments",
  "Introducing technology to agriculture and experimenting"
]


export const experience = [
  {
    title: "Technical Intern",
    company: "Rakuten India Enterprise Pvt Ltd, Bengaluru, KA",
    description: "Worked on some of the challenging problems like \"Fraud detection andprevention in Rakuten ID (An E2E IAM ecosystem developed by Eco-System Service Department(ESD)\" and other critical POCs' like MySQL integration, etc,.",
    duration: "Feb 2019 to Jun 2019",
    url: "https://corp.rakuten.co.in/"
  },
  {
    title: "Software Engineer II",
    company: "Rakuten India Enterprise Pvt Ltd, Bengaluru, KA",
    description: "Worked on tackling some of the challenging problems Rakuten ID(An E2E IAM ecosystem developed by Eco-System Service Department(ESD). Currently working in RPay (Rakutens' E2E Payment platform for Japan. Like UPI in India!).",
    duration: "Jul 2019 to Present",
    url: "https://corp.rakuten.co.in/"
  }
]



// WEBPACK FOOTER //
// ./src/data.js